import { FeatureFlag, FeatureFlagService } from '../../omnibox/services/FeatureFlagService';
import { getSessionManagementServiceInstance } from '../../omnibox/services/SessionManagementService';

export function isMetricsEnabled(): boolean {
    const sessionManagementService = getSessionManagementServiceInstance();
    return sessionManagementService.metricsOnSiteEnabled() && FeatureFlagService.instance.getValue(FeatureFlag.metricsSpaceEnabled);
}
